import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { CASETRUST_LOGO_PATH, CASETRUST_BRAND_NAME } from "@handshake/core-types";

@Component({
  selector: "core-case-trust-logo",
  standalone: true,
  imports: [CommonModule],
  template: `
    <img
      [src]="src"
      [alt]="alt"
      class="block w-auto max-w-full object-contain object-left"
      [style.height.px]="height"
    />
  `,
})
export class CoreCaseTrustLogoComponent {
  @Input() src = CASETRUST_LOGO_PATH;
  @Input() alt = `${CASETRUST_BRAND_NAME} logo`;
  /** Display height in px; width follows 545×248 source aspect ratio. */
  @Input() height = 36;
}
